module.exports = __webpack_public_path__ + "img/usd.257c29d7.png";